import React, { useMemo, useCallback } from "react";
import { Modal, Form, Row, Col, Input, message } from "antd";
import { connect } from "dva";

const UpdateLocationModal = ({
  adminShipmentView,
  dispatch,

  visible,
  onClose,
}) => {
  const [form] = Form.useForm();

  const loadId = useMemo(() => adminShipmentView?.data?.load?.id, [adminShipmentView]);

  const shipmentId = useMemo(() => adminShipmentView?.data?.id, [adminShipmentView]);

  const onUpdateLocation = useCallback(
    values => {
      if (!loadId || !shipmentId) return;

      const { lat } = values;

      const [latitude, longitude] = lat.split(",");

      dispatch({
        type: "adminShipmentView/updateLoc",
        loadId,
        latitude: latitude?.trim(),
        longitude: longitude?.trim(),
        shipmentId,
      }).then(result => {
        if (result?.error) {
          message.error("Could not update location");
          return;
        }

        message.success("Location updated!");

        if (typeof onClose === "function") {
          onClose();
        }
      });
    },
    [loadId, shipmentId, onClose, dispatch],
  );

  return (
    <Modal title="Update Location" open={visible} onOk={form.submit} onCancel={onClose}>
      <Form layout="vertical" form={form} onFinish={onUpdateLocation}>
        <Row gutter={16}>
          <Col lg={24}>
            <Form.Item
              name="lat"
              label="Latitude, Longitude"
              rules={[
                {
                  required: true,
                  message: "Please enter a valid latitude and longitude",
                },
                {
                  pattern: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/,
                  message: "Please enter a valid latitude and longitude separated by a comma",
                },
              ]}
            >
              <Input placeholder="latitude, longitude" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default connect(({ adminShipmentView }) => ({
  adminShipmentView,
}))(UpdateLocationModal);
